function goNextSlide(slide) {
  let showIndexSlider = Number(slide.dataset.opacityButton) + 1;
  let nextSlide = document.querySelector(`[data-opacity-slider="${showIndexSlider}"]`);
  nextSlide.classList.add('active');
}

function resetSlidePopup(event) {
  document.querySelectorAll('.opacity_slider__element').forEach(slide => {
    slide.classList.remove('active');
  });
  document.querySelector('[data-opacity-slider="0"]').classList.add('active');
  closePopup(event);
}

function closePopup(e) {
  const popupOverlay = e.target.closest('.general--popup__overlay');
  popupOverlay.style.display = 'none';
  popupOverlay.classList.remove('opened')
}

function overlayClosePopup(e) {
  if(!e.target.classList.contains('general--popup__overlay')) {
    return
  }
  const popupOverlay = document.querySelector('.general--popup__overlay');
  popupOverlay.style.display = 'none';
  popupOverlay.classList.remove('opened')
}

function openGeneralPopup(event) {
  let buttonIdElement = event.target.closest('[data-popup-id]')
  const popupId = buttonIdElement.dataset.popupId
  let popupToOpen = document.getElementById(popupId)
  if (popupToOpen) {
    popupToOpen.style.display = 'flex';
    setTimeout(() => popupToOpen.classList.add('opened'), 300);
  } else {
    console.error('Popup no found for id:', popupId);
  }

  if(buttonIdElement.classList.contains('cart-remove-button')) {
    let elementIndex = buttonIdElement.dataset.index
    let removeProductId = buttonIdElement.dataset.productId

    document.querySelector('cart-remove-popup-button').dataset.index = elementIndex
    document.querySelector('.wishlist--button-cart').dataset.index = elementIndex

    let removeCustomerId = document.querySelector('.wishlist--button-cart').dataset.customerId

    document.querySelector(".wishlist--button-cart").addEventListener('click', (e) => {
      addToWishlist(removeProductId, removeCustomerId)
      closePopup(e)
  })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.general--popup__overlay').addEventListener('click', overlayClosePopup)
});